import React from 'react'

export default function Label({ text }: { text: string }) {
  return <span className="text-base font-bold text-[#323539] m-0 inline">{text}</span>
}
